<div [id]="chartId" style="width: 100%; height: 400px" #chartContainer></div>
<div
  id="print-{{ chartId }}"
  style="
    width: 505px;
    height: 400px;
    visibility: hidden;
    position: absolute;
    top: -9999px;
    left: -7000px;
  "></div>
